import { useNavigate } from "react-router-dom";
import { Btn, LI, UL } from "../../../../AbstractElements";
import { useAppDispatch } from "../../../../Redux-Toolkit/Hooks";
import { HoverButtonsProp, ProductItemInterface } from "../../../../Type/EcommerceType";
import { addToCartData } from "../../../../Redux-Toolkit/Reducers/CartSlice";

export const HoverButtons = ({ item, setDataid, setOpenModal }: HoverButtonsProp) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const AddToCarts = (item: ProductItemInterface, quantity: number) => {
    dispatch(addToCartData({ item, quantity }));
    navigate(`${process.env.PUBLIC_URL}/ecommerce/cart`);
  };

  const onClickHandle = (i: ProductItemInterface) => {
    setOpenModal(true);
    setDataid(i.id);
  };

  return (
    <div className="product-hover">
      <UL className="simple-list d-flex flex-row">
        <LI>
          <Btn onClick={() => AddToCarts(item, 1)}>
            <i className="icon-shopping-cart ms-1"></i>
          </Btn>
        </LI>
        <LI>
          <Btn onClick={() => onClickHandle(item)}>
            <i className="icon-eye"></i>
          </Btn>
        </LI>
      </UL>
    </div>
  );
};
